module.exports = __webpack_public_path__ + "static/media/Space-Grotesk-Medium.8e31f12f.ttf";